<div class="modal" [ngClass]="{ 'open': isOpen, 'camera-active': cameraActive }">
  <div class="modal-container">
    <h2 class="modal-title">{{'identificar_produto' | transloco}}</h2>
    <div class="dialog-content">
      <div *ngIf="error" class="error">{{ error }}</div>
      <div class="file-input">
        <button mat-raised-button color="primary" (click)="triggerFileInput()">
          <mat-icon>photo_library</mat-icon>
          {{ selectedFile ? truncateFileName(selectedFile.name) : ('selecionar_imagem' | transloco) }}
        </button>
        <button mat-raised-button color="primary" (click)="openCamera()">
          <mat-icon>photo_camera</mat-icon>
          {{'tirar_foto' | transloco}}
        </button>
        <input type="file" accept="image/webp,image/png,image/jpeg" id="fileInput" (change)="onFileSelected($event)"
          style="display: none" />
      </div>
      <div *ngIf="selectedFile && !cameraActive" class="image-preview">
        <img [src]="imagePreviewUrl" alt="Imagem selecionada" />
      </div>
      <div *ngIf="cameraActive && !selectedFile" class="camera-container">
        <video #video autoplay playsinline></video>
        <canvas id="canvas" style="display: none;"></canvas>
        <button class="capture-button" (click)="capturePhoto()">
          <span class="inner-circle"></span>
        </button>
      </div>
      <div *ngIf="result">
        <h3>{{'resultado' | transloco}}</h3>
        <pre>{{ result | json }}</pre>
      </div>
      <mat-spinner *ngIf="loading" diameter="40"></mat-spinner>
    </div>
    <div class="dialog-actions">
      <button mat-button (click)="closeModal()">{{ 'cancelar' | transloco }}</button>
      <button mat-raised-button color="primary" (click)="identifyProduct()" [disabled]="!selectedFile || loading">
        {{ 'achar_produto' | transloco }}
      </button>
    </div>
  </div>
</div>
